export const handleRedirect = (id, history) => {
  history.push(`/od/historia-clinica/${id}`)
}
